import { apiClient } from "../../../api/client";
import * as ActionType from "./videoReport.type";

export const getVideoReport = () => async (dispatch) => {
  const res = await apiClient.get("videoReport/getAllVideoReport");
  if (res.ok) {
    dispatch({ type: ActionType.GET_VIDEO_REPORT, payload: res.data?.videoReports });
  } else {
    console.error(res.message);
  }
};

export const resolveReport = (id) => async (dispatch) => {
  const res = await apiClient.patch(
    `videoReport/resolveReport?videoReportId=${id}`
  );
  if (res.ok && res.data?.status) {
    dispatch({
      type: ActionType.UPDATE_VIDEO_REPORT,
      payload: { data: res.data?.videoReport, id },
    });
  } else {
    console.error(res.message);
  }
};

export const deleteVideoReport = (id) => async (dispatch) => {
  const res = await apiClient.delete(
    `videoReport/deleteVideoReport?videoReportId=${id}`
  );
  if (res.ok && res.data?.status) {
    dispatch({ type: ActionType.DELETE_VIDEO_REPORT, payload: id });
  } else {
    console.error(res.message);
  }
};
